import { IStudioLibraryItem } from "@app/shared/models/IStudioLibraryItem";
import { AssetType } from "@app/shared/models/assetType";

export class Decoration implements IStudioLibraryItem{
  uuid:string;
  name:string;
  type:AssetType;
  fabricElem:any;
  targetField:string;
  svgSrc:string;
  jsonSrc:string;

  id:number;
  attachmentId?:number;
  code?:string;
  searchIndex?:string;
  savePercent?:string;
  rewards?:string;
  decoration?:any;
  decorationUrl?:string;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/models/decoration.ts